import React from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'outline';
  children: React.ReactNode;
}
export function Button({
  variant = 'primary',
  className = '',
  children,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-8 py-3 text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 uppercase tracking-widest';
  const variants = {
    primary: 'bg-white text-black hover:bg-neutral-200',
    outline: 'border border-white text-white hover:bg-white hover:text-black'
  };
  return <button className={`${baseStyles} ${variants[variant]} ${className}`} {...props} data-id="element-126">
      {children}
    </button>;
}